import './bootstrap'

// Env
import { Controller } from './controllers'
const frontController = new Controller()

// We'll load jQuery and libraries.
try {
  window.$ = window.jQuery = require('jquery')

  require('jquery-confirm')
  // require('../../../node_modules/...')
} catch (e) {}

// Helpers
import {
  FNEnvironment,
  FNProportional,
  FNRegular,
  FNFormValidation
} from './helpers'

// Utilities
import {
  FNAlerts,
  Fancybox,
  Menu
} from './utilities'

// Define
const fnEnvironment = new FNEnvironment
const fnAlerts = new FNAlerts
const menu = new Menu()
const fancybox = new Fancybox()
const proportional = new FNProportional()
const regular = new FNRegular()
const form = new FNFormValidation()

// Initializers
function docReady() {
  // Framework initializers
  frontController.dispatch()

  // App & Utilities & Helpers
  fnAlerts.errors()
  fnAlerts.success()
  menu.init()
  fancybox.init()
  proportional.make()
  regular.make()
  form.validate()
}

function winLoad() {
  // Framework initializers
  // ...

  // App & Utilities & Helpers
  // ...
}

function docReadyWinload() {
  // Framework initializers
  fnEnvironment.set()

  // App & Utilities & Helpers
  // ...
}

function resize() {
  // Framework initializers
  // ...

  // App & Utilities & Helpers
  // ...
}

// [IMPORTANT] Do not change or add anything!
$(document).ready(function() {
  docReady()
  docReadyWinload()
  resize()
  $(window).resize(function() {
    resize()
  })
})
$(window).on('load', function() {
  winLoad()
  docReadyWinload()
  resize()
  $(window).resize(function() {
    resize()
  })
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js